import { render, staticRenderFns } from "./router-info-tabs.vue?vue&type=template&id=c71dacf8&"
import script from "./router-info-tabs.vue?vue&type=script&lang=ts&"
export * from "./router-info-tabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports